import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { NewQuoteDialog } from "@/components/quotes/NewQuoteDialog";
import { RecordPaymentDialog } from "@/components/quotes/RecordPaymentDialog";
import type { EventBoardDialogState } from "@/hooks/useEventBoardActions";
import { EventQuotePanel } from "./EventQuotePanel";
import { EventDetailSheet } from "./EventDetailSheet";

interface ConfirmProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  onDismiss: () => void;
}

function Confirm({ open, title, description, confirmLabel, onConfirm, onDismiss }: ConfirmProps) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onDismiss()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep it</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

/** Everything the Events board's buttons open (#1557), driven by useEventBoardActions().dialogs. */
export function EventBoardDialogs({ quote, cancel, done, payment, newEvent, detail }: EventBoardDialogState) {
  return (
    <>
      <EventQuotePanel quoteId={quote.quoteId} draft={quote.draft} onClose={quote.onClose} />
      <Confirm
        open={!!cancel.row}
        title={`Cancel ${cancel.row?.event.event_number ?? "event"}?`}
        description="A cancelled event can't be reopened from here. Its quotes stay as they are."
        confirmLabel="Cancel event"
        onConfirm={cancel.onConfirm}
        onDismiss={cancel.onDismiss}
      />
      <Confirm
        open={!!done.row}
        title={`Mark ${done.row?.name ?? "event"} done?`}
        description="It moves to Done. It can't be reopened from the board."
        confirmLabel="Mark done"
        onConfirm={done.onConfirm}
        onDismiss={done.onDismiss}
      />
      {payment.target && (
        <RecordPaymentDialog
          open
          onOpenChange={(o) => !o && payment.onClose()}
          quoteId={payment.target.quoteId}
          quoteTotal={payment.target.quoteTotal}
          amountPaid={payment.target.amountPaid}
          quoteNumber={payment.target.quoteNumber}
        />
      )}
      <NewQuoteDialog open={newEvent.open} onClose={newEvent.onClose} onCreated={newEvent.onCreated} />
      <EventDetailSheet eventId={detail.eventId} onClose={detail.onClose} />
    </>
  );
}
